import React from 'react';

/** Shared Quick Commerce mark (aligned with Amazon row in store hub). */
export default function QuickCommerceLogo({ size = 20, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={`flex-shrink-0 ${className}`}
      aria-hidden
    >
      <rect width="32" height="32" rx="8" fill="#EA580C" />
      <path
        d="M10 12h12l-1.2 8H11.2L10 12zm2.2-3h7.6l1 3H11.2l1-3z"
        fill="#fff"
      />
      <circle cx="13" cy="24" r="1.5" fill="#FED7AA" />
      <circle cx="19" cy="24" r="1.5" fill="#FED7AA" />
    </svg>
  );
}
